import React from 'react';
import { useOutletContext } from 'react-router-dom';
import SectionLabel from '../components/SectionLabel';
import ResourceCard from '../components/ResourceCard';
import Skeleton, { EmptyState } from '../components/Skeleton';
import { fetchResources, useLive } from '../data/live';

export default function ResourcesPage() {
  const { meeting } = useOutletContext();
  const event = meeting._event;

  const resources = useLive(fetchResources, [event?.id]);

  if (resources === undefined) return <Skeleton variant="card" count={2} />;
  if (!resources || !resources.length) {
    return <EmptyState>Meeting materials will be posted here as the meeting approaches.</EmptyState>;
  }

  return (
    <>
      <div className="portal-overview-body">
        Downloadable materials for the meeting. More resources will appear here as the meeting approaches.
      </div>

      <SectionLabel right={`${resources.length}`}>Available now</SectionLabel>
      <div className="portal-card-grid">
        {resources.map((r, i) => <ResourceCard key={i} resource={r} />)}
      </div>

      <SectionLabel>More coming soon</SectionLabel>
      <div className="portal-resource-placeholder">
        <div className="portal-resource-placeholder-plus" aria-hidden>+</div>
        Additional resources pending
      </div>
    </>
  );
}
